// extracted by mini-css-extract-plugin
export default {"title":"Countdown_title__pFR4P"};